import { createFileRoute } from "@tanstack/react-router";
import { ctrDesc, ctrTitle } from "@/lib/seo-copy";
import { NaatiLocaleQuestions } from "@/components/naati/NaatiLocaleQuestions";
import { NAATI_QA_LOCALE } from "@/data/naati/qa-locale";
import { NAATI_QUESTIONS_HREFLANG_LINKS } from "@/data/naati/hreflang";
import { serviceHero, serviceHeroAbsolute } from "@/data/_media/service-hero";

const URL_ = "https://thainotarylaw.com/ja/naati/questions";

export const Route = createFileRoute("/ja/naati/questions")({
  loader: () => {
    const c = NAATI_QA_LOCALE.ja;
    return {
      h: {
        meta: [
          { property: "og:image", content: serviceHeroAbsolute("naati") },
          { property: "og:image:alt", content: serviceHero("naati").altEn },
          { name: "twitter:image", content: serviceHeroAbsolute("naati") },
          { title: ctrTitle(c.title) },
          { name: "description", content: ctrDesc(c.description) },
          { property: "og:title", content: ctrTitle(c.title) },
          { property: "og:description", content: ctrDesc(c.description) },
          { property: "og:url", content: URL_ },
          { property: "og:type", content: "website" },
          { name: "twitter:card", content: "summary_large_image" },
        ],
        links: [
          { rel: "canonical", href: URL_ },
          ...NAATI_QUESTIONS_HREFLANG_LINKS,
        ],
      },
    };
  },
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => <NaatiLocaleQuestions locale="ja" />,
});
